export const usCurrencyValidator = (value: string): boolean => {
  const validated = value.match(/^(\d*\.{0,1}\d{0,2}$)/);
  if (validated) {
    return true;
  }
  return false;
};
